import styled from 'styled-components';
import { Button } from 'rsuite';
import theme from '../../../styles/theme';

export const ButtonBorderBlue = styled(Button)`
  color: ${props => props.darkMode === true ? theme.whiteColor : theme.primaryColor };
  border: 1px solid ${props => props.darkMode === true ? theme.whiteColor : theme.primaryColor };

`;
